<template>
  <div class="flex flex-row items-center">
    <button type="button" aria-label="減少數量" class="btn px-3 py-1.5 min-w-[2.5rem]" @click="minus" :disabled="disabled">
      <MinusIcon />
    </button>
    <span class="px-3 font-medium">{{ value }}</span>
    <button type="button" aria-label="增加數量" class="btn px-3 py-1.5 min-w-[2.5rem]" @click="add" :disabled="disabled">
      <PlusIcon />
    </button>
  </div>
</template>


<script>
import { MinusIcon, PlusIcon } from "@vue-hero-icons/outline";

export default {
  components: { MinusIcon, PlusIcon },
  props: {
    value: [String, Number],
    onlyonce: Boolean,
    min: {
      type: Number,
      default: 1,
    },
    disabled: Boolean
  },

  methods: {
    add() {
      if (this.disabled) return;
      this.$emit("input", this.value + 1);
    },
    minus() {
      if (this.disabled) return;
      if (this.value <= this.min) return;
      const qty = this.value - 1;

      this.$emit("input", qty);
    },
  },
};
</script>
